import { render, staticRenderFns } from "./BannerLoading.vue?vue&type=template&id=34bd85fa&scoped=true&"
var script = {}
import style0 from "./BannerLoading.vue?vue&type=style&index=0&id=34bd85fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bd85fa",
  null
  
)

export default component.exports